import React from "react";
import JobNote from "../../../types/jobNote";
import { Grid, useTheme } from "@mui/material";
import { Base } from "../../base";
import moment from "moment";
import JobEquipment from "../../../types/jobEquipment";
import JobVendor from "../../../types/jobVendor";
import { Delete } from "@mui/icons-material";
import { useSelector } from "../../../store";

interface Props {
  note?: JobNote;
  equipment?: JobEquipment;
  vendor?: JobVendor;
  setDeleteNoteModal?: React.Dispatch<
    React.SetStateAction<{
      id?: number;
      note?: string | undefined;
      type?: "equipment" | "vendor" | "time" | undefined;
    }>
  >;
}

const JobNoteDisplay: React.FC<Props> = (props) => {
  const { note, equipment, vendor, setDeleteNoteModal } = props;
  const theme = useTheme();
  const { loggedInUser } = useSelector((store) => store.authentication);
  const { simpleUserList } = useSelector((store) => store.user);

  return (
    <Grid
      container
      direction={"column"}
      sx={{
        backgroundColor: theme.palette.background.default,
        paddingX: "10px",
        borderRadius: "10px",
      }}
      marginY={1}
    >
      <Grid sx={{ paddingY: "10px" }}>
        {equipment?.equipment && (
          <>
            <Base.Text
              text={`${equipment.equipment.name}: $${equipment.equipment.value}`}
            />
            <Base.Text text={`Quantity: ${equipment.quantity}`} />
          </>
        )}

        {(note?.note || vendor?.vendor)?.split("\n").map((t, key) => (
          <Base.Text text={t} key={key} />
        ))}
      </Grid>
      <Grid sx={{ borderTop: "1px solid black" }}>
        <Grid
          container
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ py: "5px" }}
        >
          <Grid>
            <Base.Text
              text={`Added by ${
                simpleUserList.find(
                  (u) => u.id === (note || equipment || vendor)?.createdById,
                )?.value
              } on ${moment((note || equipment || vendor)?.createdOn).format(
                "MM/DD/YY",
              )}`}
            />
          </Grid>
          <Grid>
            {setDeleteNoteModal &&
              simpleUserList.find(
                (u) => u.id === (note || equipment || vendor)?.createdById,
              ) === loggedInUser?.id && (
                <Base.IconButton
                  icon={<Delete />}
                  label="Delete"
                  onClick={() => {
                    setDeleteNoteModal({
                      id: (note || equipment || vendor)?.id!,
                      note:
                        note?.note ||
                        equipment?.equipment?.name ||
                        vendor?.vendor,
                      type: equipment
                        ? "equipment"
                        : vendor
                        ? "vendor"
                        : undefined,
                    });
                  }}
                />
              )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default JobNoteDisplay;
